module.exports = __webpack_public_path__ + "img/table-bus-icon.ae7d10f2.svg";